import React, { useEffect, useState, useMemo, useRef } from 'react'
import LoginLeft from './LoginLeft'
import './login.scss';
import Form from 'react-bootstrap/Form';
import { useHistory, useLocation } from 'react-router-dom';
import Notify from 'lib/Utils/Alert';
import Authenticate from 'lib/Core/Authenticate';
import NotificationAlert from "react-notification-alert";
import Spinner from 'react-bootstrap/Spinner';
import CryptoJS from 'crypto-js';
const securityGroups = [
  "purchaser"
]

const SendOtp = () => {
  const history = useHistory()
  const [otpPath, setOtpPath] = useState('')
  const [phoneVerified,setPhoneVerified] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const notifyRef = useRef();
  const location = useLocation();
  const { state } = location;
  const  password = JSON.parse(sessionStorage.getItem("password"));
  const  username =  JSON.parse(sessionStorage.getItem("username"));
  const authCtl = useMemo(() => new Authenticate(securityGroups), [securityGroups]);
 
  function NotifyMsg(msg, type) {
    Notify(notifyRef, type, msg);
  }


  
  useEffect(() => {

    if (state?.state?.msg) {
      NotifyMsg(state?.state?.msg)
    }

  }, [state?.state?.msg])


  const sendOtp = () => {
    if (otpPath !== '') {
      setButtonDisabled(true)
      authCtl.requestMFACode(username, password, otpPath).then(data => {
        setTimeout(() => {
          setButtonDisabled(false)
        }, 1500);
        if (data.Success === true) {
            history.replace('/purchaser-auth/verify-otp')
            sessionStorage.setItem("otpPath", JSON.stringify(otpPath));
            sessionStorage.setItem("verifyed", JSON.stringify("verifyed"));
            sessionStorage.setItem("smsVerified", JSON.stringify("smsVerified"))
            // window.location.reload();
        } else {
          if(data?.errorCode == "NUMBER_NOT_VERIFIED"){
            setTimeout(() => {
              setButtonDisabled(false)
            }, 1500);
          setPhoneVerified(true)
          } else {
            setPhoneVerified(false)
            setTimeout(() => {
              setButtonDisabled(false)
            }, 1500);
          }
          NotifyMsg(data.errorMessage, "danger");
        }
      }).catch((error) => {
        setButtonDisabled(false)
        setTimeout(() => {
          setButtonDisabled(false)
        }, 1500);
        // NotifyError(error.errorMessage);
      });

    } else {
      setTimeout(() => {
        setButtonDisabled(false)
      }, 1500);
      NotifyMsg("Please select an option to get OTP", "danger");
    }
  }

  const veriFyPhone=()=>{
    authCtl.getPhoneNoVerificationCodeFromCognito(username).then(data =>{
      if (data.status === 'true') {
        setPhoneVerified(false)
        history.replace('/purchaser-auth/verify-otp', { state: {"flag": "phoneVerify"} })
        window.location.reload();
      } else {
        NotifyMsg(data.errorMessage)
      }
    })
  }


  useEffect(() => {
    const handleKeyPress = () => {
      sendOtp()
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);



  return (
    <div className='authPage'>
      <NotificationAlert ref={notifyRef} />

      <div className="wrap">
        <div className="row g-0">
          <div className="col-lg-6">
            <LoginLeft hideCursor={true} />
          </div>
          <div className="col-lg-6">
            <div className="authRight h-100 p-4 p-lg-5">

            {phoneVerified ? 
              <div className="authRightContent">
                <h3>Enter OTP Code </h3>
              <div className='verifyBox verifyBoxShadow'>
              <div className='col text-center'> 
                <h6 className='mb-4 fs-6 fw-semi'>Do you want to verify your Phone number ?</h6>

                <div className="mb-3">
                  <button className='btn btn-primary w-10' onClick={()=> veriFyPhone()} >Yes</button>
                  <button className='btn btn-primary w-10' onClick={()=> setPhoneVerified(false)} >No</button>
                </div>
                </div>
              </div>
              </div>

              :
              <div className="authRightContent">
                <h3>Enter OTP Code.. </h3>
                <h6 className='mb-4 fs-6 fw-semi'>Your code has been sent to your OTP preferred delivery method</h6>
                {['radio'].map((type) => (
                  <div key={`inline-${type}`} className="mb-3">
                    <Form.Check
                      onChange={(e) => setOtpPath(e.target.value)}
                      inline
                      label="Email"
                      name="otpPath"
                      type={type}
                      value={"mail"}
                      id={`inline-${type}-1`}

                    />
                    <Form.Check
                      onChange={(e) => setOtpPath(e.target.value)}
                      inline
                      label="SMS"
                      name="otpPath"
                      type={type}
                      value={"sms"}
                      id={`inline-${type}-2`}
                    />
                  </div>
                ))}
                <button className='btn btn-primaryTwo w-100' disabled={buttonDisabled} onClick={sendOtp}>{!buttonDisabled && "Send OTP"}{
                  buttonDisabled && 
                  <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{
                  margin: "0px 8px"
                  }}
                />
                  }</button>
              </div>
}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SendOtp